<template>
  <div class="page-tags">
    <div
      @click="toHomePage"
      :class="[{'home-page-tags-active': $route.path === '/home/home-page'}, 'home-page-tags']">
      <img v-if="$route.path === '/home/home-page'" class="home-img" src="../../assets/images/home-hign.png">
      <img v-else class="home-img" src="../../assets/images/home.png">
    </div>
    <div
      v-for="(item, index) in tags"
      :key="index"
      :class="[{active:item.url === $route.path}, 'tags-container']"
      @click="toUrl(item)"
    >
     <el-tooltip effect="dark" :content="item.menuName" placement="bottom" :disabled="item.menuName.length > 8?false:true">
        <span class="title">
          {{ item.menuName.length > 8 ? `${item.menuName.substr(0,8)}...` : item.menuName }}
        </span>
      </el-tooltip>
      <i class="el-icon-close" @click.stop="closeTags(index)"></i>
    </div>
  </div>
</template>

<script>
import authMixins from '@/common/mixins/auth.js'
import { saveTags, getTags, getUserSetHomeKeyWord } from '@/common/js/storage';
import FILTER_TAGS from '@/common/menu/filterTags'
import toolTip from '@/components/base/toolTip.vue'
export default {
  mixins: [authMixins],
  components: {
    toolTip
  },

  data() {
    return {
      tags: [],
    }
  },
  
  watch: {
    $route(to) {
      if (to.path !== '/home/home-page') {
        let arr = this.tags
        let obj = {...to.meta}
        obj.url = to.path
        let isIndex = arr.findIndex(item => item.menuName === to.meta.menuName)
        if (isIndex === -1) {
          obj.time = new Date().getTime()
        } else {
          obj.time = arr[isIndex].time
        }
        obj.query = {...to.query}
        arr.push(obj)
        let index = FILTER_TAGS.findIndex(item => item.url === to.path)
        if (index !== -1) {
          // 查询到有子页面切换的页面
          let tagsArr = []
          if (arr.length === 0) {
            tagsArr.push(obj)
          } else {
            arr.map(i => {
              // 判断tags有没有和当前点击页面名称相同，相同就替换
              if (i.menuName === to.meta.menuName) {
                tagsArr.push(obj)
              } else {
                tagsArr.push(i)
              }
            })
          }
          arr = [...tagsArr]
        }
        let tags = this.unique(arr)
        this.tags = tags.sort((a, b) => { return a.time - b.time })
        saveTags(this.tags)
      }
    }
  },

  created() {
    this.$bus.on('updateTags', () => {
      this.initTags()
    })
  },

  beforeDestroy() {
    this.$bus.$off('updateTags');
  },

  methods: {
    initTags() {
      let arr = getTags()
      if (arr.length > 0) {
        let tagsArr = this.unique(arr)
        tagsArr.map(i => {
          if (i.authKeyWord === getUserSetHomeKeyWord()) {
            i.isHome = 0
          } else {
            i.isHome = 1
          }
        })
        this.tags = tagsArr.sort((a, b) => { return a.isHome - b.isHome })
      } else {
        if (this.$route.path !== '/home/home-page') {
          let obj = this.$route.meta
          obj.url = this.$route.path
          obj.query = this.$route.query
          this.tags.push(obj)
          saveTags(this.tags)
        }
      }
    },

    toUrl(row) {
      this.$router.push({
        path: row.url,
        query: row.query
      })
    },

    closeTags(index) {
      this.tags.splice(index, 1)
      saveTags(this.tags)
      if (this.tags[index] === undefined) {
        if (this.tags[index-1] === undefined) {
          // 没有tags跳转首页
          this.toHomePage()
        } else {
          this.toUrl(this.tags[index-1])
        }
      } else {
        this.toUrl(this.tags[index])
      }
    },

    toHomePage() {
      let row = {
        url: '/home/home-page',
        query: {}
      }
      this.toUrl(row)
    },

    /** 
     * @desc 去重(后面替换前面的)
    */
    unique(arr) {
      let res = []
      let map = new Map()
      for (let i of arr) {
        map.set(i.url, i)
      }
      res = [...map.values()]
      return res
    }
  }
}
</script>

<style lang='scss'>
.page-tags {
  width: 100%;
  height: 44px;
  background: $baseSnow;
  padding-right: 14px;
  box-sizing: border-box;
  @include flex-start;
  @include scrollbarNotrack();
  overflow-x: auto;
  .home-page-tags {
    width: 44px;
    height: 44px;
    @include flex-center;
    cursor: pointer;
    .home-img {
      width: 16px;
      height: 16px;
    }
    &:hover {
      background: white;
    }
  }
  .home-page-tags-active {
    background: white;
  }
  .tags-container {
    min-width: 50px;
    height: 100%;
    font-size: 14px;
    color: $baseGrey;
    line-height: 22px;
    padding: 0px 10px;
    @include flex-start;
    box-sizing: border-box;
    cursor: pointer;
    border-right: 1px solid $baseThreeSnow;
    flex-shrink: 0;
    .title {
      flex: 1;
    }
    .el-icon-close {
      margin-left: 9px;
      font-weight: 800;
    }
    &:hover {
      background: white;
      color: $baseBlue;
    }
  }
  .active {
    background: white;
    color: $baseBlue;
    .el-icon-close {
      color: $baseGrey;
    }
  }
}
</style>
